import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Groups } from '@app/client';
import { type CreateSocialGroup } from '@app/gen';

import { PODS_SIDEBAR_FOLLOWING_CACHE_KEY } from './useGetGroups';
import { groupsCacheKeys } from './utils';

/**
 * React Hook using React Query useMutation to create a new group.
 */
export const useCreateGroup = () => {
    const queryClient = useQueryClient();

    return useMutation((value: CreateSocialGroup) => Groups.callPostGroup({ value }), {
        onSuccess: () => {
            queryClient.invalidateQueries(PODS_SIDEBAR_FOLLOWING_CACHE_KEY);
            queryClient.invalidateQueries(groupsCacheKeys.groupsKey);
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onError: (_error: Error) => {
            queryClient.invalidateQueries(groupsCacheKeys.groupsKey);
        },
    });
};
